<template>
  <div class="d-flex flex-column align-center">
    <img
      :src="doctorReview.avatar_small.url"
      alt="/"
      class="mb-4 rounded-circle"
      :style="{ width: '80px', height: '80px', objectFit: 'cover' }"
    >
    <div class="text-center mb-4">
      <div class="text-subtitle-1">
        {{ doctorReview.surname }} {{ doctorReview.firstname }} {{ doctorReview.secondname }}
      </div>
      <div class="text-body-2 mb-4 text-secondary--text">
        {{ doctorReview.position }}
      </div>
      <div class="text-body-1 px-2">
        {{ doctorReviewText }}
      </div>
    </div>
    <v-btn
      class="primary--text"
      text
      @click="toggleShowMore"
    >
      {{ isShowMore ? t('Скрыть', options) : t('Показать всё', options) }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import {
  computed,
  nextTick,
  ref,
} from 'vue'
import I18NextVue from 'i18next'
import { DoctorReview } from 'src/components/pages/info/pressa/types'
import { Swiper } from 'swiper'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  doctorReview: DoctorReview
  swiperInstance: Swiper | null
}>()
const isShowMore = ref(false)
const doctorReviewText = computed(() => (
  isShowMore.value ? props.doctorReview.text : `${props.doctorReview.text.slice(0, 150)}...`))

async function toggleShowMore() {
  isShowMore.value = !isShowMore.value

  if (props.swiperInstance) {
    await nextTick()

    props.swiperInstance.updateAutoHeight(300)
  }
}
</script>
